import { ProductDoc } from '@gooduncles/gu-app-schema';
import { FC } from 'react';

import ProductItemWithFetch from '../../ProductItem/ProductItemWithFetch/ProductItemWithFetch';
import classes from './GridProductList.module.scss';

interface GridProductListWithFetchProps {
  productIds: ProductDoc['_id'][];
  promotion?: string;
}

const GridProductListWithFetch: FC<GridProductListWithFetchProps> = ({ productIds, promotion }) => {
  return (
    <div className={classes.gridProductList}>
      {productIds.map((productId) => (
        <ProductItemWithFetch key={productId} productId={productId} promotion={promotion} />
      ))}
    </div>
  );
};

export default GridProductListWithFetch;
